import formAppLayout from './formAppContent';

export default {
  title: 'Content Form',
  attributeName: 'appLayoutForm',
  getURL: 'appId/areaId/appContentPlay',
  createURL: 'appId/areaId/appContentPlay',
  updateURL: 'appId/areaId/appContentPlay',
  additionaMetadataURL: 'appId/additionalMetadata/AppContent',
  removeURL: '',
  idAttribute: 'id',
  idUpdate:true,
  sessionParams: ['appId', 'areaId'],
  updateReduxWhen:['composeExperienceObj'],
  formConfig: formAppLayout,
  autoUpdate: false,
  noArea: true,
  goBack: true,
};
